<template>
  <div class="countdown" :class="{ 'expired': isExpired }">
    {{ h }}:{{ m }}:{{ s }}.
    <div class="ms-node" :style="{ '--ms-delay': msDelay }"></div>
  </div>
</template>

<script setup lang="ts">
import {ref, onMounted, onUnmounted, watch} from 'vue'


const props = defineProps<{ endTime: number }>()

const h = ref('00')
const m = ref('00')
const s = ref('00')
const msDelay = ref('0s')
const isExpired = ref(false)

let timer: number | null = null

const update = () => {
  const now = Date.now()
  const remain = props.endTime - now

  if (remain <= 0) {
    h.value = m.value = s.value = '00'
    isExpired.value = true
    if (timer) clearInterval(timer)
    return
  }

  // 计算时分秒
  h.value = Math.floor(remain / 3600000).toString().padStart(2, '0')
  m.value = Math.floor((remain % 3600000) / 60000).toString().padStart(2, '0')
  s.value = Math.floor((remain % 60000) / 1000).toString().padStart(2, '0')

  // 同步 CSS 毫秒动画：
  // 利用负延迟让 0-9 的 CSS 滚动动画直接跳到当前的毫秒进度
  const currentMs = remain % 1000
  msDelay.value = `-${1000 - currentMs}ms`
}

onMounted(() => {
  update()
  timer = window.setInterval(update, 1000)
})

onUnmounted(() => {
  if (timer) clearInterval(timer)
})

watch(() => props.endTime, () => {
  isExpired.value = false
  update()
})
</script>

<style scoped lang="sass">
// SASS 缩进语法 (无分号，无花括号)

.countdown
  display: inline-flex
  align-items: center
  font-variant-numeric: tabular-nums
  /* 或更精确的写法 */
  font-feature-settings: "tnum"


  // 毫秒单节点容器
  .ms-node
    height: 1em
    line-height: 1em
    overflow: hidden

    &::after
      // 使用 \a 换行符生成 0-9 数字序列
      content: "0\a 9\a 8\a 7\a 6\a 5\a 4\a 3\a 2\a 1"
      white-space: pre
      display: block
      text-align: center
      // 应用动画并使用 JS 传入的负延迟变量同步时间
      animation: slide-num 1s steps(10) infinite
      animation-delay: var(--ms-delay)

  &.expired
    .ms-node::after
      animation: none
      content: "0"

// 垂直滚动动画
@keyframes slide-num
  from
    transform: translateY(0)
  to
    transform: translateY(-100%)
</style>